export { Badge, badgeVariants, type BadgeProps } from './Badge';
